module.exports = __webpack_public_path__ + "img/weibo.19cd402d.png";